import axios from "axios";
import { connection_platform } from "./configConnection";

const instance = axios.create({
  baseURL: connection_platform.urlCommunicatedBackend
});

export default instance;
